import React from 'react';
import { Wifi, WifiOff, RefreshCw, CloudUpload } from 'lucide-react';
import { useOfflineSync } from '@/hooks/useOfflineSync';

/* Indicador pequeño y persistente de conexión / pendientes de sincronizar */
export const OfflineIndicator = () => {
  const { isOnline, status, pending, syncNow } = useOfflineSync();

  let bg = 'bg-[#22C55E]/15 border-[#22C55E]/40 text-[#22C55E]';
  let Icon = Wifi;
  let label = 'En línea';
  let spin = false;

  if (!isOnline) {
    bg = 'bg-[#FF6B00]/15 border-[#FF6B00]/50 text-[#FF6B00]';
    Icon = WifiOff;
    label = 'Sin conexión';
  } else if (status === 'syncing') {
    bg = 'bg-[#00CFFF]/15 border-[#00CFFF]/50 text-[#00CFFF]';
    Icon = RefreshCw;
    label = 'Sincronizando';
    spin = true;
  } else if (pending.total > 0) {
    bg = 'bg-[#FF6B00]/15 border-[#FF6B00]/50 text-[#FF6B00]';
    Icon = CloudUpload;
    label = 'Por sincronizar';
  }

  return (
    <button
      type="button"
      onClick={() => isOnline && syncNow()}
      title={isOnline ? 'Toca para sincronizar ahora' : 'Las capturas se guardan en este dispositivo'}
      data-testid="offline-indicator"
      data-online={isOnline ? 'true' : 'false'}
      data-pending={pending.total}
      className={`fixed bottom-2 left-2 z-[10000] flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold backdrop-blur-md transition-colors duration-200 ${bg}`}
      style={{ backgroundColor: 'rgba(6,12,24,0.85)' }}
    >
      <Icon className={`w-3 h-3 ${spin ? 'animate-spin' : ''}`} />
      <span data-testid="offline-indicator-label">{label}</span>
      {pending.total > 0 && (
        <span
          data-testid="offline-indicator-pending"
          className="ml-0.5 rounded-full bg-current/20 px-1.5 text-[10px] leading-4"
        >
          {pending.total} pendiente{pending.total !== 1 ? 's' : ''}
        </span>
      )}
    </button>
  );
};

export default OfflineIndicator;
